<template>
  <v-dialog v-model="dialog" :max-width="modalWidth">
    <v-btn slot="activator" flat text color="primary"
      ><slot>Change Password</slot></v-btn
    >
    <v-card class="rounded-card elevation-6 pa-3">
      <v-toolbar dark color="primary lighten-2">
        <v-toolbar-title>Change Password</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-alert
          v-if="error"
          :value="true"
          type="error"
          icon="warning"
          class="mb-4"
        >
          {{ errorMessage }}
        </v-alert>
        <v-form
          ref="form"
          v-model="valid"
          class="px-3"
          lazy-validation
          @submit.prevent
        >
          <v-text-field
            v-model="oldPassword"
            :append-icon="showOldPassword ? 'visibility' : 'visibility_off'"
            prepend-icon="lock"
            name="currentPassword"
            label="Current Password"
            :type="showOldPassword ? 'text' : 'password'"
            :rules="currentRules"
            required
            class="my-1"
            @click:append="showOldPassword = !showOldPassword"
          ></v-text-field>
          <v-text-field
            v-model="newPassword"
            :append-icon="showPassword ? 'visibility' : 'visibility_off'"
            prepend-icon="lock"
            name="password"
            browser-autocomplete="off"
            label="New Password"
            :type="showPassword ? 'text' : 'password'"
            :rules="passwordRules"
            required
            class="my-1"
            hint="At least 7 characters"
            counter
            @click:append="showPassword = !showPassword"
          ></v-text-field>
        </v-form>
      </v-card-text>
      <v-card-actions class="mt-2 grey lighten-5 rounded-card">
        <v-btn flat text color="primary" @click="forgot"
          ><span>Forgot password?</span></v-btn
        >
        <v-spacer></v-spacer>
        <v-btn flat round outline color="primary" @click="dialog = false">
          <span>Cancel</span>
        </v-btn>
        <v-btn
          round
          :disabled="!valid"
          type="submit"
          color="accent"
          :loading="loading"
          @click="submit"
        >
          <v-icon small left>lock</v-icon>
          Change
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex';
const MODAL_WIDTH = '600px';

export default {
  props: {
    email: { type: String, default: null }
  },
  data: function() {
    return {
      valid: true,
      showOldPassword: false,
      showPassword: false,
      error: false,
      errorMessage: 'Error.',
      passwordRules: [
        v => !!v || 'New password is required',
        v => (v && v.length >= 7) || 'Minimum 7 characters'
      ],
      currentRules: [v => !!v || 'Existing password is required'],
      newPassword: null,
      oldPassword: null,
      loading: false,
      dialog: false,
      modalWidth: MODAL_WIDTH
    };
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    dialog: function(visible, hidden) {
      if (visible) {
        this.modalWidth =
          window.innerWidth < MODAL_WIDTH ? MODAL_WIDTH / 2 : MODAL_WIDTH;
        this.newPassword = null;
        this.oldPassword = null;
        this.showOldPassword = false;
        this.showPassword = false;
        this.error = false;
        this.errorMessage = null;
        this.loading = false;
        this.$refs.form.resetValidation();
      }
    }
  },
  methods: {
    forgot() {
      if (this.email && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.email)) {
        this.$router.push(`/forgot?email=${encodeURIComponent(this.email)}`);
      } else {
        this.$router.push('/forgot');
      }
    },
    async submit() {
      if (this.$refs.form.validate()) {
        if (this.newPassword === this.oldPassword) {
          this.errorMessage = 'Passwords cannot be the same.';
          this.error = true;
        } else {
          this.error = false;
          this.loading = true;
          const result = await this.updatePassword({
            newPassword: this.newPassword,
            oldPassword: this.oldPassword
          });
          // eslint-disable-next-line
          // console.log('result -->', result);
          this.loading = false;
          if (result && result.success) {
            this.setSnack(result.message);
            this.dialog = false;
            this.newPassword = null;
            this.oldPassword = null;
            this.showOldPassword = false;
            this.showPassword = false;
            this.error = false;
            this.errorMessage = null;
            this.$refs.form.resetValidation();
          } else {
            this.errorMessage = result.message;
            this.error = true;
          }
        }
      }
    },
    ...mapActions({
      updatePassword: 'account/updatePassword',
      setSnack: 'snackbar/setSnack'
    })
  }
};
</script>
<style>
.rounded-card {
  border-radius: 10px;
}
</style>
